import { styled, Typography, useTheme, Box } from '@mui/material'
import InputErrorSvg from 'assets/images/svg/common/input-error.svg'
interface InputErrorProps {
  error?: boolean
  message?: string
}
const ErrorBox = styled(Box)`
  display: flex;
  align-items: center;
  padding: 16px;
  margin: 24px 0 4px;
  width: 100%;
  justify-content: center;
  /* background-color: ${props => props.theme.colors.red[200]}; */
  .MuiTypography-root {
    line-height: 16px;
  }
  img {
    margin-right: 12px;
  }
`
export default function InputError({ error = false, message }: InputErrorProps) {
  const theme = useTheme()
  return error && message ? (
    <ErrorBox>
      <img src={InputErrorSvg} alt="" />
      <Typography variant="subtitle2" component="div" color={theme.colors.red[200]}>
        {message}
      </Typography>
    </ErrorBox>
  ) : (
    <></>
  )
}
